import React, { ReactElement, forwardRef } from "react";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
// import Typography from "@mui/material/Typography";

import Dialog from "@mui/material/Dialog";
import { theme } from "../../theme";
import CloseIcon from "@mui/icons-material/Close";
// import IconButton from "@mui/material/IconButton";
import FdTypography from "../UIComponents/Typography/FdTypography";
import FdButton from "../UIComponents/Button/FdButton";
import FdIconButton from "../UIComponents/IconButton/FdIconButton";

export enum actionDialogType {
  REGULAR = "regular",
  WARNING = "warning",
}

export interface Props {
  open: boolean;
  title?: string;
  onConfirm?: Function;
  content?: string | ReactElement;
  icon?: React.ReactElement;
  confirmLabel?: string;
  onCancel?: Function;
  cancelLabel?: string;
  onClose?: Function;
  type?: actionDialogType;
  isLoading?: boolean;
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
  fullWidth?: boolean;
  disablePortal?: boolean; // The children will be under the DOM hierarchy of the parent component.
}

const classes = {
    wrapper: {
      padding: "35px",
      textAlign: "center",
    },
    loading: {
      marginTop: "20px",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  } as const;

const SimpleActionDialog = (
  {
    open,
    title,
    content,
    icon,
    onConfirm,
    confirmLabel = "Yes",
    onCancel,
    cancelLabel = "No",
    onClose,
    type = actionDialogType.REGULAR,
    isLoading,
    maxWidth,
    fullWidth,
    disablePortal,
  }: Props,
  ref: any
) => {
  const handleConfirmClick = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    }
  };
  const handleCancelClick = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  };
  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Dialog
      onClose={() => {
        !isLoading && handleClose();
      }}
      aria-labelledby="dialog-title"
      open={open}
      ref={ref}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      disablePortal={disablePortal}
    >
      {onClose && !isLoading && (
        <FdIconButton
          aria-label="close"
          sx={classes.closeButton}
          onClick={handleClose}
          size="large"
          Icon={<CloseIcon />}
          />            
      )}
      <Box sx={classes.wrapper}>
        {icon &&
          React.cloneElement(icon, {
            style: {
              marginBottom: "15px",
            },
            color:
              type === actionDialogType.REGULAR
                ? theme.palette.primary.main
                : theme.palette.error.main,
          })}
        <FdTypography
          label= {title || ""}
          variant="h2"
          component="h2"
          sx={{ marginBottom: "15px", wordBreak:"break-word" }}
        />
        <Box>{content}</Box>
        {!isLoading && (
          <Box>
            {onConfirm && (
              <FdButton
                size="medium"
                onClick={handleConfirmClick}
                sx={{
                  marginTop: "20px",
                  marginBottom: "10px",
                  backgroundColor:
                    type === actionDialogType.REGULAR
                      ? theme.palette.primary.main
                      : theme.palette.error.main,
                }}
                ButtonName={confirmLabel}
              />
            )}
            {onCancel && (
               <FdButton
                size="medium"
                onClick={handleCancelClick}
                sx={{
                  marginTop: "20px",
                  marginBottom: "10px",
                  marginLeft: "15px",
                  backgroundColor:
                    type === actionDialogType.REGULAR
                      ? theme.palette.primary.main
                      : theme.palette.error.main,
                }}
                ButtonName={cancelLabel}
                />
            )}
          </Box>
        )}
        {isLoading === true && <CircularProgress sx={classes.loading} />}
      </Box>
    </Dialog>
  );
};

export default forwardRef(SimpleActionDialog);
